/* ============================================================
   PANIER : "-" SUR UNE QUANTITE DE 1 = SUPPRIMER LA LIGNE
   ------------------------------------------------------------
   Comportement Dawn d'origine : l'input a min="1", donc stepDown()
   ne fait rien et le bouton "-" est juste grise / bloque (message
   "minimum 1 quantity"). Le client doit viser la petite croix pour
   retirer l'article.
   Ici, quand la quantite est deja au minimum, le "-" declenche
   exactement la meme action que la croix (cart-remove-button, qui
   envoie quantity = 0). On ne reimplemente donc AUCUNE logique de
   panier : on reutilise le chemin officiel de Dawn.

   Ce fichier n'agit QUE dans un panier (.cart-item) : la quantite
   sur la fiche produit garde son comportement normal.

   L'ecouteur est pose une seule fois sur document, en phase de
   capture : il survit aux re-rendus du panier (tiroir et page
   /cart remplacent leur contenu par innerHTML) et passe avant le
   gestionnaire de Dawn, que l'on neutralise dans ce cas precis.
   ============================================================ */
(function () {
  'use strict';

  // Le fichier est charge par le tiroir ET par la page /cart :
  // on ne pose l'ecouteur qu'une fois.
  if (window.cartMinusRemovesInstalled) return;
  window.cartMinusRemovesInstalled = true;

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var minus = target.closest('.quantity__button[name="minus"]');
      if (!minus) return;

      // Uniquement dans une ligne de panier.
      var item = minus.closest('.cart-item');
      if (!item) return;

      // Les lignes imbriquees (produits groupes) n'ont pas de bouton
      // de suppression : on les laisse au comportement d'origine.
      if (item.classList.contains('cart-item__nested-line')) return;

      var wrapper = minus.closest('quantity-input') || item;
      var input = wrapper.querySelector('input.quantity__input');
      if (!input) return;

      var current = parseInt(input.value, 10);
      if (isNaN(current)) return;

      // ATTENTION : c'est data-min qui fait foi, pas l'attribut min.
      // Dans le panier Dawn met min="0" sur l'input mais compare la
      // valeur saisie a data-min (la regle de quantite du produit,
      // 1 par defaut) dans cart.js -> validateQuantity(). C'est de la
      // que venait le message "Minimum of 1", suivi d'une remise a 1.
      var min = parseInt(input.dataset.min, 10);
      if (isNaN(min)) min = parseInt(input.min, 10);
      if (isNaN(min)) min = 1;

      // Au-dessus du minimum : comportement normal (decrementer).
      if (current > min) return;

      var removeButton = item.querySelector('cart-remove-button');
      if (!removeButton) return; // pas de bouton officiel : on ne touche a rien

      // On empeche le gestionnaire de Dawn de traiter ce clic.
      event.preventDefault();
      event.stopPropagation();

      removeButton.click();
    },
    true
  );
})();
